<template>
    <div style="height: 100%;">
        <myself-software v-if="currentTab=='software'"></myself-software>
        <train-task v-else-if="currentTab=='trainTask'"></train-task>
    </div>
</template>

<script>
import MyselfSoftware from '../personCenter/MyselfSoftware.vue'
import TrainTask from './softwareMag/TrainTask.vue'
    export default {
  components: { MyselfSoftware, TrainTask },
  computed:{
            /**当前tab */
            currentTab(){
                    return this.$store.state.backend.currentTab;
                }
        },
    }
</script>

<style lang="less" scoped>

</style>